import { Newsletter } from '@df/session/newsletter/newsletter.interfaces';

export class NewsletterUpdateEvent {
    constructor(public readonly data: Newsletter.ISubscribeRequest | Newsletter.IUnsubscribeRequest) {}
}
